import { render, staticRenderFns } from "./Officials.vue?vue&type=template&id=07746ebe&scoped=true"
import script from "./Officials.vue?vue&type=script&lang=js"
export * from "./Officials.vue?vue&type=script&lang=js"
import style0 from "./Officials.vue?vue&type=style&index=0&id=07746ebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07746ebe",
  null
  
)

export default component.exports